module.exports = __webpack_public_path__ + "img/11088038_L.f0755e68.png";